export default __webpack_public_path__ + "static/media/video.12d48fba.svg";